import { apiService } from './api';

export const supplierService = {
  // Récupérer tous les fournisseurs
  getSuppliers: async (params = {}) => {
    const response = await apiService.get('/suppliers', params);
    return response.data;
  },

  // Récupérer un fournisseur par ID
  getSupplier: async (id) => {
    const response = await apiService.get(`/suppliers/${id}`);
    return response.data;
  },

  // Créer un nouveau fournisseur
  createSupplier: async (supplierData) => {
    const response = await apiService.post('/suppliers', supplierData);
    return response.data;
  },

  // Mettre à jour un fournisseur
  updateSupplier: async (id, supplierData) => {
    const response = await apiService.put(`/suppliers/${id}`, supplierData);
    return response.data;
  },

  // Supprimer un fournisseur
  deleteSupplier: async (id) => {
    const response = await apiService.delete(`/suppliers/${id}`);
    return response.data;
  },

  // Les produits d'un fournisseur — paginés depuis RU5-e.
  getSupplierProducts: async (id, params = {}) => {
    const response = await apiService.get(`/suppliers/${id}/products`, params);
    return response.data;
  },

  // Les commandes d'un fournisseur — paginées, ordonnées, avec l'en-cours.
  getSupplierOrders: async (id, params = {}) => {
    const response = await apiService.get(`/suppliers/${id}/orders`, params);
    return response.data;
  },

  // Créer rapidement un fournisseur
  quickCreateSupplier: async (supplierData) => {
    const response = await apiService.post('/suppliers/quick-create', supplierData);
    return response.data;
  },
}; 